import { formatDateTime } from '@/lib/format'
import { messages } from '@/lib/messages'
import { cn } from '@/lib/utils'
import { useRealtimeStore } from '@/stores/realtime-store'

const STATUS_LABEL: Record<string, string> = {
  connecting: messages.realtime.connecting,
  open: messages.realtime.live,
  reconnecting: messages.realtime.reconnecting,
  closed: messages.realtime.offline,
}

const STATUS_DOT: Record<string, string> = {
  connecting: 'bg-[var(--chart-3)]',
  open: 'bg-[var(--chart-5)]',
  reconnecting: 'bg-[var(--chart-3)]',
  closed: 'bg-destructive',
}

/** Bağlantı durumu topbar'da: kullanıcı tazeliğin durumunu görsün (görev dosyası). */
export function RealtimeIndicator() {
  const status = useRealtimeStore((state) => state.status)
  const lastEventAt = useRealtimeStore((state) => state.lastEventAt)

  return (
    <div
      className="text-muted-foreground flex items-center gap-1.5 text-xs"
      title={
        lastEventAt
          ? `${messages.realtime.lastEventLabel}: ${formatDateTime(lastEventAt)}`
          : messages.realtime.noEventYet
      }
    >
      <span className={cn('size-2 rounded-full', STATUS_DOT[status])} aria-hidden="true" />
      {/* Mobilde yalnız nokta; etiket ekran okuyucuya kalır, üst çubuk taşmasın. */}
      <span className="sr-only sm:not-sr-only">{STATUS_LABEL[status]}</span>
    </div>
  )
}
